import App from "./ConfiguraComfort.svelte";
const initConfig = {
    mainTitle: "Customize your Accora Configura Comfort",
    bookADemoHref: "https://accora.care/book-a-join-visit",
};
export const ConfiguraComfort = (targetId, config) => {
    const app = new App({
        target: document.getElementById(targetId),
        props: {
            config: Object.assign(Object.assign({}, initConfig), config),
        },
    });
    return app;
};
window.ConfiguraComfort = ConfiguraComfort;
export default ConfiguraComfort;
